import firebase from "../../firebase";

export default function({ officeId, roomId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "pagingAdmin",
        funcName: "removeRoomFromOffice",
        data: {
            officeId,
            roomId
        }
    });
}
